<div class="wrapper">
    <!-- Payment failed error -->
    <div *ngIf="error" class="data-state__error">
        <ion-icon style="font-size: xx-large;" color="primary" name="warning"></ion-icon>
        <p>Betaling is mislukt of geannuleerd</p>
        <ion-button color="secondary" (click)="startCardPayment()">Probeer opnieuw</ion-button>
    </div>

    <!-- NFC Unsupported -->
    <div *ngIf="!nfcSupported" class="data-state__error">
        <ion-icon style="font-size: xx-large;" color="danger" name="alert-circle"></ion-icon>
        <p>Dit toestel ondersteunt geen NFC.</p>
    </div>

    <!-- NFC Disabled -->
    <div *ngIf="nfcSupported && !nfcEnabled" class="data-state__error">
        <ion-icon style="font-size: xx-large;" color="warning" name="alert"></ion-icon>
        <p>NFC is uitgeschakeld. Schakel het in via de instellingen.</p>
    </div>

    <ng-container *ngIf="!error && nfcSupported && nfcEnabled">
        <div class="payment__info">
            <p>TOTAAL: {{ data.order.order.totalPrice | currency: 'EUR' }}</p>
        </div>

        <img src="../../../../../../../../assets/img/tap-to-pay-transparent.png" alt="Tap to Pay">

        <ion-button *ngIf="!paymentInProgress" expand="block" color="secondary" (click)="startCardPayment()"
            [disabled]="paymentInProgress || disableRetry">
            Start kaartbetaling
        </ion-button>

        <p *ngIf="paymentInProgress && !error" class="processing-message">
            Kaartbetaling wordt verwerkt, even geduld...
        </p>
    </ng-container>
</div>